// extracted by css-extract-rspack-plugin
export default {"title":"title-KM3GKU","subtitle":"subtitle-QtGRhW","row":"row-oAMCla","rowLabel":"rowLabel-ye41t5","rowValue":"rowValue-h7Ua7W"};